import { AxiosResponse } from 'axios';
import { normalizeEvaluation } from '../normalization';
import {
  GetEvaluationInput,
  NormalizedEvaluation,
  Evaluation,
  InvoiceBookResponse,
  PostEvaluationInput,
} from '../types';
import { client } from './axiosClient';

export const getEvaluationURL = async (
  company_id: string | undefined,
  id: number
) => {
  const res = await client.post<string>(
    `/client/invoice-book/${id}/download`,
    undefined,
    {
      params: {
        company_id,
      },
    }
  );
  return res.data;
};

export const getEvaluation = async (
  company_id: string | undefined,
  params: GetEvaluationInput
): Promise<NormalizedEvaluation | null> => {
  const res = await client.get<Evaluation>('/client/invoice-book', {
    params: {
      company_id,
      ...params,
    },
  });

  if (res.status === 204) {
    return null;
  }

  return normalizeEvaluation(res.data);
};

export const getInvoiceBook = async (
  company_id: string | undefined,
  type: 'month' | 'quarter',
  year: number,
  value: number,
  is_oss: number,
  page: number,
  vat_country_id: number | undefined
) => {
  const res = await client.get<InvoiceBookResponse>(
    '/client/invoice-book/items',
    {
      params: {
        company_id,
        year,
        [type]: value,
        is_oss,
        page,
        vat_country_id,
      },
    }
  );
  return res.data;
};
export const postEvaluation = async (
  company_id: string | undefined,
  input: PostEvaluationInput
) => {
  const res = await client.post<PostEvaluationInput, AxiosResponse<Evaluation>>(
    '/client/invoice-book',
    input,
    {
      params: {
        company_id,
      },
    }
  );
  return normalizeEvaluation(res.data);
};
